/* @ngInject */
function WorkflowBriefingsController () { }

export { WorkflowBriefingsController }
